import React, { useState } from "react";

import PolicyPlanCustomRecordTemplateContext from "../../../contexts/PolicyPlanCustomRecordTemplateContext";

import PageTitleNew from "../../ui/PageTitleNew";
import Table from "./Table";
import ModalForm from "./Form/Modal";

export default function Index() {
  return (
    <PolicyPlanCustomRecordTemplateContext>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Custom Services" />

        <div className="ibox-content mt20">
          <Table />
        </div>
      </div>
      <ModalForm />
    </PolicyPlanCustomRecordTemplateContext>
  );
}
